/**
 * Bot Check Collector - Tracks bot check results from authentication and other security checks
 */

import { EventCollector, EventManager } from '../core';
import { TrackingEventType, BotCheckEvent } from '../types';

export class BotCheckCollector implements EventCollector {
  private eventManager: EventManager;
  private static instance: BotCheckCollector | null = null;

  constructor(eventManager: EventManager) {
    this.eventManager = eventManager;
    // Store instance for global access
    BotCheckCollector.instance = this;
  }

  /**
   * Get the singleton instance
   */
  static getInstance(): BotCheckCollector | null {
    return BotCheckCollector.instance;
  }

  start(): void {
    // No automatic event listeners needed for bot checks
    // Bot check events are tracked explicitly when they occur
  }

  stop(): void {
    // Nothing to stop
  }

  destroy(): void {
    BotCheckCollector.instance = null;
  }

  /**
   * Track a bot check result
   */
  trackBotCheck(params: {
    isBot: boolean;
    isBotBypass: boolean;
    isBotBypassReason?: string;
    reason?: string;
    reasonCode?: string;
    score?: number;
    checkType: 'login' | 'signup' | 'action';
    action?: string;
    success: boolean;
  }): void {
    this.eventManager.track({
      eventType: TrackingEventType.BOT_CHECK,
      data: params
    });
  }

  /**
   * Convenience method to track login bot check results
   */
  trackLoginBotCheck(
    botCheckResult: {
      isBot: boolean;
      isBotBypass: boolean;
      isBotBypassReason?: string;
      reason?: string;
      reasonCode?: string;
      score?: number;
    },
    success: boolean
  ): void {
    this.trackBotCheck({
      ...botCheckResult,
      checkType: 'login',
      success
    });
  }
}
